<ngx-ui-loader></ngx-ui-loader>
<app-toast></app-toast>

<router-outlet>

</router-outlet>


